// import Home from "./home/home";
import PinSection from "~/js/home/pin-section";
import Common from "~/js/common/common";
import store from "~/js/store/store";
import Header from "~/js/common/header";
import Footer from "~/js/common/footer";
import SideNavi from "~/js/home/side-navi";
import Modal from "~/js/common/modal";
import Tooltip from "~/js/common/tooltip";
import ImportantModal from "~/js/common/important-modal";
export default class Index {
  constructor() {
    store.dispatch("home");
    store.subscribe((mutation, state) => {
      if (mutation.type === "beforeScroll") {
        this.updateSideNavi();
        
      } else if (mutation.type === "init") {
        this.init();
      }
    });
    this.header = new Header();
    this.footer = new Footer();
    this.sideNavi = new SideNavi();
    const home = document.getElementById("home");
    const autoPlayEnabled = home?.dataset.homeAutoplay === "true";
    new PinSection({
      autoPlay: autoPlayEnabled
    });
    this.setupImportantNotice();

    new Tooltip();
  }
  setupImportantNotice() {
    let importantNotice = document.querySelector(".js-important-notice");
    if (!importantNotice) {
      return;
    }
    this.modal = new Modal();
    new ImportantModal();
    let home = document.getElementById("home")
    home.classList.add("notice")
  }

  init() {
    window.scrollTo(0, 0);
    Common.init();
  }

  // サイドナビ更新
  updateSideNavi() {
    if (this.sideNavi) {
      this.sideNavi.updateNavi();
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  new Index();
});
